import { palierEffectifOrg } from './mrr'
import type { Organisation } from './types'

/** `dd/mm/yyyy`, vide si absente — format qu'Excel France lit comme une date. */
function jour(iso: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
}

/**
 * Une cellule CSV. Séparateur `;` (Excel France).
 *
 * ⚠️ Une cellule qui commence par `=`, `+`, `-` ou `@` est lue comme une
 * FORMULE par Excel. Le nom d'une organisation vient d'un tenant : un nom
 * `=HYPERLINK(...)` s'exécuterait chez l'administrateur qui ouvre l'export.
 * On le neutralise d'une apostrophe — la version HTML ne le faisait pas.
 */
export function cellule(valeur: string | number | null | undefined): string {
  let s = valeur === null || valeur === undefined ? '' : String(valeur)
  if (/^[=+\-@\t\r]/.test(s) && typeof valeur !== 'number') s = `'${s}`
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export function typeOrganisation(o: Pick<Organisation, 'is_operator' | 'is_white_label'>): string {
  return o.is_operator ? 'Opératrice' : o.is_white_label ? 'Marque blanche' : 'SaaS'
}

export const ENTETE_CSV = [
  'Organisation', 'Type', 'Plan', 'Abonnement', 'Membres', 'Livreurs', 'Véhicules',
  'Courses 30j', 'Courses total', 'Revenu cumulé', 'Dernier paiement', 'Créée le',
  'Fin de période', 'Palier effectif',
] as const

export function construireCsv(organisations: readonly Organisation[], maintenant: Date): string {
  const lignes: (string | number | null)[][] = [[...ENTETE_CSV]]
  for (const o of organisations) {
    lignes.push([
      o.brand_name || o.name, typeOrganisation(o), o.plan_tier, o.sub_status ?? '',
      o.members, o.drivers, o.vehicles, o.courses_30d, o.courses_total, o.revenue_fcfa,
      jour(o.last_payment), jour(o.created_at), jour(o.period_end), palierEffectifOrg(o, maintenant),
    ])
  }
  // BOM : sans lui Excel lit « Véhicules » en Windows-1252.
  return '﻿' + lignes.map((l) => l.map(cellule).join(';')).join('\n')
}
